// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 588) return "static/chunks/588-aae18947eb896856.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 374 ? "2fbf9dd2" : chunkId) + "." + {"27":"9c289971a0018e7e","74":"71d0850040e453ee","100":"bdbce1edd0edc539","157":"a4b9544fd9328735","255":"0b2fae70bb6945f0","341":"4527570350441bd9","374":"5ccc7336bce0682c","553":"d09c562f624dab86","770":"b6e0ec99caca8532","891":"28d2f6926167069c","946":"0cf01b0854641193"}[chunkId] + ".js";
};